
import './TicketForm.css';
import React, { useState } from "react";
// Importaciones de Firebase
import { initializeApp } from "firebase/app";
import { getFirestore, collection, addDoc } from "firebase/firestore";

// --- Configuración de Firebase ---
// ¡IMPORTANTE! Reemplaza estos valores con la configuración de tu proyecto Firebase.
// Puedes encontrar esto en tu Consola de Firebase, en 'Configuración del proyecto' > 'Tus apps' > 'Web'.
const firebaseConfig = {
    apiKey: "AIzaSyASw54RgoJOoqugZVYR4K0sh25REUohEWQ", // Por ejemplo: "AIzaSyC..."
    authDomain: "crm-cetys-30eae.firebaseapp.com",
    projectId: "crm-cetys-30eae", // Este es tu Project ID: crm-cetys-30eae
    storageBucket: "crm-cetys-30eae.firebasestorage.app",
    messagingSenderId: "214581899654",
    appId: "1:214581899654:web:a71b748e6a3643e8743c07" // Por ejemplo: "1:214581899654:web:..."
};

// Inicializa Firebase (asegúrate de que esto se haga solo una vez en tu aplicación)
const app = initializeApp(firebaseConfig);
const db = getFirestore(app);

const TicketForm = () => {
    // Estado del formulario
    const [formData, setFormData] = useState({
        nombre1: "",
        nombre2: "",
        direccion: "",
        telefono: "",
        detalle: "",
        motivos: []
    });

    // Función para manejar cambios en los campos del formulario
    const handleChange = (e) => {
        const { name, value, type, checked } = e.target;

        if (type === "checkbox") {
            setFormData((prev) => {
                if (checked) {
                    return { ...prev, motivos: [...prev.motivos, value] };
                } else {
                    return { ...prev, motivos: prev.motivos.filter((m) => m !== value) };
                }
            });
        } else {
            setFormData({ ...formData, [name]: value });
        }
    };

    // Función para manejar el envío del formulario
    const handleSubmit = async (e) => { // Marcamos la función como 'async' para poder usar 'await'
        e.preventDefault();

        // VALIDACIÓN
        if (!formData.nombre1.trim()) {
            return alert("Por favor ingrese el nombre.");
        }
        if (!formData.nombre2.trim()) {
            return alert("Por favor ingrese el apellido.");
        }
        if (!formData.direccion.trim()) {
            return alert("Por favor ingrese la dirección.");
        }
        if (!formData.telefono.trim()) {
            return alert("Por favor ingrese un número de teléfono.");
        }
        if (formData.motivos.length === 0) {
            return alert("Debe seleccionar al menos un motivo de solicitud.");
        }

        // CONFIRMACIÓN TÉCNICA
        const confirmacion = window.confirm(
            "¿Confirma que desea enviar esta información? Los datos serán procesados para diagnóstico técnico, trazabilidad y generación del ticket."
        );

        if (confirmacion) {
            try {
                // Aquí es donde enviamos los datos a Cloud Firestore
                await addDoc(collection(db, "tickets"), {
                    ...formData,
                    timestamp: new Date() // Opcional: añade una marca de tiempo para saber cuándo se creó el ticket
                });

                alert("Datos enviados correctamente y registrados en Firebase. ¡Un técnico pronto se pondrá en contacto!");
                
                // Opcional: Reiniciar el formulario después de un envío exitoso
                setFormData({
                    nombre1: "",
                    nombre2: "",
                    direccion: "",
                    telefono: "",
                    detalle: "",
                    motivos: []
                });

            } catch (error) {
                console.error("Error al enviar el ticket a Firestore:", error);
                alert("Hubo un error al enviar su solicitud. Por favor, inténtelo de nuevo.");
            }
        } else {
            alert("Envío cancelado por el usuario.");
        }
    };

    return (
        <div className="container">
            <h1>GENERADOR DE TICKET</h1>
            <p>soporte técnico</p>
            
            <form onSubmit={handleSubmit}>
                <label>Nombre:</label>
                <div className="input-group">
                    <input type="text" name="nombre1" placeholder="Nombre" onChange={handleChange} value={formData.nombre1} />
                    <input type="text" name="nombre2" placeholder="Apellido" onChange={handleChange} value={formData.nombre2} />
                </div>

                <label>Dirección:</label>
                <input type="text" name="direccion" className="full-width" placeholder="Dirección" onChange={handleChange} value={formData.direccion} />

                <label>Número de teléfono:</label>
                <input type="text" name="telefono" placeholder="Teléfono" onChange={handleChange} value={formData.telefono} />

                <label>Motivo de solicitud</label>
                <table className="motivo-table">
                    <tbody>
                        {[
                            "Pc no enciende",
                            "No imprime",
                            "Velocidad Lenta",
                            "No responde portal",
                            "Cable fuente dañados",
                            "Problemas conexión",
                            "Otros"
                        ].map((motivo, index) => (
                            <tr key={index}>
                                <td key={`motivo-text-${index}`}>{motivo}</td>
                                <td key={`motivo-checkbox-${index}`}>
                                    <input
                                        type="checkbox"
                                        name="motivo"
                                        value={motivo}
                                        onChange={handleChange}
                                        checked={formData.motivos.includes(motivo)} // Asegura que el estado del checkbox esté controlado
                                    />
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>

                <label>Detalle del problema:</label>
                <input
                    type="text"
                    name="detalle"
                    className="full-width"
                    placeholder="Escriba el detalle del problema"
                    onChange={handleChange}
                    value={formData.detalle}
                />

                <button type="submit">ENVIAR</button>
            </form>
        </div>
    );
};

export default TicketForm;